export default __webpack_public_path__ + "static/media/bpro.39fc589c.svg";